import { Image } from 'antd';

export default function Logo() {
    return (
        <Image
            preview={false}
            src="/atravel.png"
            style={{
                margin: "auto",
            }}
        />
    );
}
